import React from 'react';

/**
 * Builds a windowed page list: 1 … 4 5 [6] 7 8 … 20
 * The same function was duplicated in Home, HotProducts, NewArrival,
 * AlsoLike and Search.
 */
export const buildPageList = (currentPage, lastPage) => {
  const current = Number(currentPage);
  const last = Number(lastPage);
  if (!Number.isFinite(current) || !Number.isFinite(last) || last < 2) return [];

  const pages = [];
  const start = Math.max(1, current - 2);
  const end = Math.min(last, current + 2);

  if (start > 1) {
    pages.push(1);
    if (start > 2) pages.push('start-ellipsis');
  }

  for (let page = start; page <= end; page += 1) pages.push(page);

  if (end < last) {
    if (end < last - 1) pages.push('end-ellipsis');
    pages.push(last);
  }

  return pages;
};

const Pagination = ({ currentPage, lastPage, onPageChange }) => {
  const pages = buildPageList(currentPage, lastPage);
  if (pages.length === 0) return null;

  return (
    <nav className="pagination" aria-label="Pagination">
      <button
        type="button"
        className="pagination__item"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage <= 1}
        aria-label="Previous page"
      >
        ‹
      </button>

      {pages.map((page) =>
        typeof page === 'number' ? (
          <button
            key={page}
            type="button"
            className="pagination__item"
            onClick={() => onPageChange(page)}
            aria-current={page === currentPage ? 'page' : undefined}
            aria-label={`Page ${page}`}
            disabled={page === currentPage}
          >
            {page}
          </button>
        ) : (
          <span key={page} className="pagination__ellipsis" aria-hidden="true">
            …
          </span>
        )
      )}

      <button
        type="button"
        className="pagination__item"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage >= lastPage}
        aria-label="Next page"
      >
        ›
      </button>
    </nav>
  );
};

export default Pagination;
